import {
  SAVE_TOKEN,
  SAVE_TOKEN_PAGE,
} from "appRedux/constants";
import { SS } from "utils";

const INIT_STATE = {
  loading: false,
  tokens: [],
  tokenPages: {}
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_TOKEN: {
      SS.save("tokens", action.payload);
      return {
        ...state,
        loading: false,
        tokens: action.payload
      };
    }
    case SAVE_TOKEN_PAGE: {
      return {
        ...state,
        loading: false,
        tokenPages: action.payload
      };
    }
    default:
      return state;
  }
};
